import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/invoices/new")({
  beforeLoad: () => {
    throw redirect({
      to: "/invoices/$id/edit",
      params: { id: "new" },
    });
  },
});
